export default {
  appName: 'Ahora Patagonia',
  loading: 'Loading…',
  error: 'Something went wrong',
  retry: 'Retry',
  actions: {
    save: 'Save',
    cancel: 'Cancel',
    create: 'Create',
    edit: 'Edit',
    delete: 'Delete',
    back: 'Back',
    close: 'Close',
    confirm: 'Confirm',
  },
  nav: {
    home: 'Home',
  },
  home: {
    welcome: 'Welcome. Customize your sections in layout/nav.tsx.',
  },
  auth: {
    title: 'Ahora Patagonia',
    subtitle: 'Sign in to continue',
    emailLabel: 'Email',
    passwordLabel: 'Password',
    togglePassword: 'Show/hide password',
    forgotLink: 'Forgot your password?',
    submit: 'Sign in',
    hero: {
      titleStrong: 'Ahora Patagonia',
      titleSoft: 'all in one place.',
      subtitle: 'Run your operation with a simple, secure platform.',
    },
    forgot: {
      backToLogin: 'Back to sign in',
      request: { title: 'Reset password', subtitle: 'Enter your email and we will send you a code.', submit: 'Send code' },
      verify: { title: 'Verify the code', subtitle: 'Check your email and enter the 6-digit code.', codeLabel: 'Code', submit: 'Verify' },
      reset: { title: 'New password', subtitle: 'Choose a new password (min. 8 characters).', newPasswordLabel: 'New password', submit: 'Change password' },
      done: { title: 'Done!', subtitle: 'Your password was changed. You can sign in now.' },
    },
  },
  language: {
    label: 'Language',
    es: 'Spanish',
    en: 'English',
  },
} as const;
